export default function ErrorState({ children, className="" }) {
  return (
    <div className={`h-full flex items-center justify-center ${className}`}>
      <p className="text-center text-pretty max-w-sm text-sm text-gray-500 p-8">{children}</p>
    </div>
  );
}
